import React from "react";
import MainPage from "../mainPage";


const HomePage = () => {

    return (
        <>
            <div className="col-12 d-flex justify-content-center text-start pb-4">
                <div className="row width-full-page pb-5 ">
                    <div className="col-md-12">
                        <div className="page1">
                            <MainPage/>
                      </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default HomePage;
